import { graphql } from '@apollo/react-hoc';
import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

export const query = gql`
  query withUserAccount {
    userAccount {
      joinedAt
      onboardedAt
      isArtist
      metrics {
        followers
        favorites
        productsSold
      }
      analytics {
        artistUploadsGroup
        artistSalesGroup
      }
      followedIds(limit: 1000)
      homepage
    }
  }
`;

const withUserAccount = Component =>
  graphql(query, {
    props: ({ data: { loading, userAccount }, ownProps }) => {
      return {
        ...ownProps,
        loading,
        userAccount: userAccount || {}
      };
    }
  })(Component);

withUserAccount.displayName = 'withUserAccount';

export const useUserAccount = () => useQuery(query);

export default withUserAccount;
